import ValidationInterface from "@/plans/common/validation-interface";
import {
  bizPlusCategories, eduPlusCategories, proPlusCategories, ZPCallingPlanCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    //require calling plans
    return [this.current("ZPA").require([...ZPCallingPlanCategories, ...proPlusCategories, ...bizPlusCategories, ...eduPlusCategories], { billingCycleEqual: true })];
  }

  async conflicts() {
    return this.current(["ZPA"]).conflict(["ZPA"]);
  }
}
